import { toFormData } from "axios";
import server_api from "data/server_apis/server_api";

// Category

export const createCategory = (data) => {
  return server_api.postForm("/commodity/category", toFormData(data));
};

export const updateCategory = (id, data) => {
  return server_api.patchForm(`/commodity/category/${id}`, toFormData(data));
};

export const getCategories = () => {
  return server_api.get("/commodity/category");
};

export const getCategory = (id) => {
  return server_api.get(`/commodity/category/${id}`);
};

export const deleteCategory = (id) => {
  return server_api.delete(`/commodity/category/${id}`);
};

// SubCategory

export const createSubCategory = (data) => {
  return server_api.postForm("/commodity/sub-category", toFormData(data));
};

export const updateSubCategory = (id, data) => {
  return server_api.patchForm(
    `/commodity/sub-category/${id}`,
    toFormData(data)
  );
};

export const getSubCategories = (cat_id) => {
  if (cat_id) {
    return server_api.get(`/commodity/sub-category?category=${cat_id}`);
  } else {
    return server_api.get("/commodity/sub-category");
  }
};

export const getSubCategory = (id) => {
  return server_api.get(`/commodity/sub-category/${id}`);
};

export const deleteSubCategory = (id) => {
  return server_api.delete(`/commodity/sub-category/${id}`);
};

// Product
export const createProduct = (data) => {
  return server_api.postForm("/commodity/product", toFormData(data));
};

export const updateProduct = (id, data) => {
  return server_api.patchForm(`/commodity/product/${id}`, toFormData(data));
};

export const getProducts = (category, subCategory, hsn = "", has_gst = "",page=1,page_size="") => {
  return server_api.get(
    `/commodity/product?category=${category}&sub_category=${subCategory}&productgst__HSNCODE=${hsn}&has_gst=${has_gst}&page=${page}&page_size=${page_size}`
  );
};

export const getProduct = (id) => {
  return server_api.get(`/commodity/product/${id}`);
};

export const deleteProduct = (id) => {
  return server_api.delete(`/commodity/product/${id}`);
};

// Product images

export const createProductImage = (data) => {
  return server_api.postForm("/commodity/product-image", toFormData(data));
};

export const updateProductImage = (id, data) => {
  return server_api.patchForm("/commodity/product-image", toFormData(data));
};

export const getProductImages = () => {
  return server_api.get("/commodity/product-image");
};

export const getProductImage = (id) => {
  return server_api.get(`/commodity/product-image/${id}`);
};

export const deleteProductImage = (id) => {
  return server_api.delete(`/commodity/product-image/${id}`);
};

// Product videos

export const createProductVideo = (data) => {
  return server_api.postForm("/commodity/product-image", toFormData(data));
};

export const updateProductVideo = (id, data) => {
  return server_api.patchForm("/commodity/product-image", toFormData(data));
};

export const getProductVideos = () => {
  return server_api.get("/commodity/product-image");
};

export const getProductVideo = (id) => {
  return server_api.get(`/commodity/product-image/${id}`);
};

export const deleteProductVideo = (id) => {
  return server_api.delete(`/commodity/product-video/${id}`);
};

// Product variant
export const getProductVariant = (id) => {
  return server_api.get(`/commodity/product-variant?product=${id}`);
};

export const createProductVariant = (data) => {
  return server_api.post("/commodity/product-variant", data);
};
export const updateProductVariant = (id, data) => {
  return server_api.patch(`/commodity/product-variant/${id}`, data);
};
export const deleteProductVariant = (id) => {
  return server_api.delete(`/commodity/product-variant/${id}`);
};

// Product offers
export const getProductOffers = (id) => {
  return server_api.get(`/commodity/offers-to-product?product=${id}`);
};

export const createProductOffer = (data) => {
  return server_api.post("/commodity/offers-to-product", data);
};
export const updateProductOffer = (id, data) => {
  return server_api.patch(`/commodity/offers-to-product/${id}`, data);
};
export const deleteProductOffer = (id) => {
  return server_api.delete(`/commodity/offers-to-product/${id}`);
};

// Product validation
export const getProductValidations = () => {
  return server_api.get(`/commodity/product-validation`);
};

export const createProductValidation = (data) => {
  return server_api.postForm("/commodity/product-validation", toFormData(data));
};
export const updateProductValidation = (id, data) => {
  return server_api.patchForm(
    `/commodity/product-validation/${id}`,
    toFormData(data)
  );
};
export const deleteProductValidation = (id) => {
  return server_api.delete(`/commodity/product-validation/${id}`);
};

// Product validation allocation

export const getValidationAllocations = ({ p_id, c_id, s_id }) => {
  return server_api.get(
    `/commodity/validation-assignment?product=${p_id ?? ""}&category=${
      c_id ?? ""
    }&sub_category=${s_id ?? ""}`
  );
};

export const createValidationAllocation = (data) => {
  return server_api.post("/commodity/validation-assignment", data);
};
export const updateValidationAllocation = (id, data) => {
  return server_api.patch(`/commodity/validation-assignment/${id}`, data);
};
export const deleteValidationAllocation = (id) => {
  return server_api.delete(`/commodity/validation-assignment/${id}`);
};

// Product grouping

export const getProductGroups = () => {
  return server_api.get(`/commodity/product-group/get_detailed`);
};

export const createProductGroup = (data) => {
  return server_api.post("/commodity/product-group", data);
};
export const updateProductGroup = (id, data) => {
  return server_api.patch(`/commodity/product-group/${id}`, data);
};
export const deleteProductGroup = (id) => {
  return server_api.delete(`/commodity/product-group/${id}`);
};

// Product grouping items
export const getProductGroupImages = (id) => {
  return server_api.get(`/commodity/product-group/${id}/get-product-images`);
};

export const setProductGroupImage = (id, data) => {
  return server_api.post(`/commodity/product-group/${id}/insert-product-image`, data);
};

export const getProductGroupItems = () => {
  return server_api.get(`/commodity/product-group-item`);
};

export const createProductGroupItem = (data) => {
  return server_api.post("/commodity/product-group-item", data);
};
export const updateProductGroupItem = (id, data) => {
  return server_api.patch(`/commodity/product-group-item/${id}`, data);
};
export const deleteProductGroupItem = (id) => {
  return server_api.delete(`/commodity/product-group-item/${id}`);
};

// Assign validation to machine
export const getValidationAssignmentsToMachine = (id) => {
  return server_api.get(
    `/commodity/validation-assignment-to-machine?machine=${id}`
  );
};
export const createValidationAssignmentsToMachine = (data) => {
  return server_api.post("/commodity/validation-assignment-to-machine", data);
};
export const updateValidationAssignmentsToMachine = (id, data) => {
  return server_api.patch(
    `/commodity/validation-assignment-to-machine/${id}`,
    data
  );
};
export const deleteValidationAssignmentsToMachine = (id) => {
  return server_api.delete(`/commodity/validation-assignment-to-machine/${id}`);
};

// Assign Sms to machine
export const getSmsAssignmentsToMachine = (id) => {
  return server_api.get(`/notifications/sms-service-allocation?machine=${id}`);
};
export const createSmsAssignmentsToMachine = (data) => {
  return server_api.post("/notifications/sms-service-allocation", data);
};
export const updateSmsAssignmentsToMachine = (id, data) => {
  return server_api.patch(`/notifications/sms-service-allocation/${id}`, data);
};
export const deleteSmsAssignmentsToMachine = (id) => {
  return server_api.delete(`/notifications/sms-service-allocation/${id}`);
};

// Allocation management
export const getSmsAssignments = () => {
  return server_api.get(`/notifications/sms-service-allocation`);
};
export const createSmsAssignments = (data) => {
  return server_api.post("/notifications/sms-service-allocation", data);
};
export const updateSmsAssignments = (id, data) => {
  return server_api.patch(`/notifications/sms-service-allocation/${id}`, data);
};
export const deleteSmsAssignments = (id) => {
  return server_api.delete(`/notifications/sms-service-allocation/${id}`);
};

// GST

export const getGst = () => {
  return server_api.get(`/commodity/product-gst`);
};
export const createGst = (data) => {
  return server_api.post("/commodity/product-gst", data);
};
export const updateGst = (id, data) => {
  return server_api.patch(`/commodity/product-gst/${id}`, data);
};
export const deleteGst = (id) => {
  return server_api.delete(`/commodity/product-gst/${id}`);
};

// HSN

export const getHsn = () => {
  return server_api.get(`/commodity/product-gst/get_hsn`);
};

// Product filter

export const getCategoryForMachine = (machine) => {
  return server_api.get(`/commodity/category/for-machine?id=${machine}`);
};

export const getSubCategoryForMachine = (machine, category) => {
  return server_api.get(
    `/commodity/sub-category/for-machine?id=${machine}&category=${category}`
  );
};

export const getProductForMachine = (machine, sub_category) => {
  return server_api.get(
    `/commodity/product/for-machine?id=${machine}&sub_category=${sub_category}`
  );
};

export const getProductVariantForMachine = (machine, product) => {
  return server_api.get(
    `/commodity/product-variant/for-machine?id=${machine}&product=${product}`
  );
};
